
import {
  Box,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import React, {  } from "react";
import "./Table.scss";

const MultiSelect = ({
    label,
    list,
    selectedValues,
    handleChange,
}) => {
    return(
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <FormControl size="small" sx={{ minWidth: 220 }}>
            <InputLabel>{label}</InputLabel>
            <Select
              multiple
              value={selectedValues}
              onChange={handleChange}
              input={<OutlinedInput label={label} />}
              renderValue={(sel) => sel.join(", ").toUpperCase()}
            >
              {list.map(opt => (
                <MenuItem key={opt} value={opt}>
                  <Checkbox checked={selectedValues.includes(opt)} />
                  <ListItemText primary={opt.toUpperCase()} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
    );
};

export default MultiSelect;